import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Customer } from '../../types/customerTypes';
import CustomerForm from './CustomerForm';
import styles from './AddCustomer.module.scss';

const AddCustomer: React.FC = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Check if user has permission to add customers
  const canAddCustomers = auth.user?.role === 'admin' || 
    auth.user?.permissions?.canManageCustomers;

  if (!canAddCustomers) {
    return (
      <div className={styles.errorContainer}>
        <h2>Access Denied</h2>
        <p>You don't have permission to add customers.</p>
        <button onClick={() => navigate('/customers')}>
          Back to Customers
        </button>
      </div>
    );
  }

  const handleSubmit = async (customerData: Partial<Customer>) => {
    setLoading(true);
    try {
      // Mock API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // In a real app, this would call the API
      // await customerService.createCustomer(customerData);
      
      console.log('Customer created:', customerData);
      
      // Navigate back to customer list
      navigate('/customers');
    } catch (error) {
      console.error('Failed to create customer:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.addCustomer}>
      <CustomerForm
        onSubmit={handleSubmit}
        loading={loading}
        mode="create"
      />
    </div>
  );
};

export default AddCustomer; 